import React from 'react'
import { WarningIcon } from 'icons';

const IconValueWarning = React.forwardRef((props, ref) =>
  <span {...props} ref={ref}>
    <WarningIcon {...props} style={{ fontSize: '1.2857142857142856rem' }} />
  </span>);

export default IconValueWarning;